import { render } from "./krudh-modal.vue?vue&type=template&id=23df17e2"
import script from "./krudh-modal.vue?vue&type=script&lang=js"
export * from "./krudh-modal.vue?vue&type=script&lang=js"

import "./krudh-modal.vue?vue&type=style&index=0&id=23df17e2&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__